import React, { useEffect, useState } from "react";
import TYGraphView from "./TenYearsData.jsx/TYGraphView";
import { useChartContext } from "../../Context/ChartsContext";
import { downloadImage, months } from "../../Utilitie";

import Controller from "../DRMDiry/Old____________comps/Controller";
import TYGraph from "../DRMDiry/Old____________comps/TYGraph";

let catA = ["PUN_MAIL", "PUN_PASS", "MEXP_RPT", "PASS_RPT", "TOD_RPT"];
let catB = [
  "LDG_MT",
  "LDG_WGN",
  "EARN_CRORES",
  "UNLDG_WGN",
  "DWB",
  "NTKMS",
  "WKMS",
  "WTR",
];
let catC = [
  "SPEED_INCLU_STB",
  "SPEED",
  "AC_USG",
  "AC_KM",
  "DSL_USG",
  "DSL_KM",
  "EMPTY_W_KM",
  "TOTAL_KM",
];

const GraphView = () => {
  const { bestSheetDataObj } = useChartContext();
  const [colData, setColData] = useState();
  const [catD, setCatD] = useState([]);
  const [tempColData, setTempColData] = useState();
  const [openStates, setOpenStates] = useState({ selectMonth: false });
  //////STATES FOR CONTROLLER ///////////////////////
  const [viewMonth, setViewMonth] = useState(months);
  const [cMonthsData, setCMonthsData] = useState(months);
  const [chartType, setChartType] = useState("line");

  const [yearDif, setYearDif] = useState(10);

  const [selectedCol, setSelectedCol] = useState({
    PUN_MAIL: true,
    PUN_PASS: true,
    LDG_MT: true,
    LDG_WGN: true,
    SPEED_INCLU_STB: true,
    SPEED: true,
    RECEIPT_RKS: true,
    DESP_RKS: true,
  });
  useEffect(() => {
    let exclude = [
      "ID",
      "F_YEAR",
      "C_YEAR",
      "A_MONTH",
      "F_MONTH",
      "C_MONTH",
      "MO_YR_ID",
    ];
    if (bestSheetDataObj.bestSheetData) {
      const keys = Object.entries(
        bestSheetDataObj.bestSheetData[0].months[0].data
      )

        .filter(([key]) => !exclude.includes(key)) // remove "ID"
        .map(([key]) => key); // extract keys

      setColData(keys);
    }
  }, [bestSheetDataObj]);
  const handleClick = (e) => {
    const colName = e.target.value;
    setSelectedCol((prev) => ({
      ...prev,
      [colName]: !prev[colName],
    }));
  };

  const handleSelectAll = () => {
    const allSelected = {};
    colData.forEach((col) => {
      allSelected[col] = true;
    });
    setSelectedCol(allSelected);
  };

  const handleClearAll = () => {
    const allCleared = {};
    colData.forEach((col) => {
      allCleared[col] = false;
    });
    setSelectedCol(allCleared);
  };

  useEffect(() => {
    let data = [];
    Object.entries(selectedCol).map(([key, value]) => {
      if (value) {
        data.push(key);
      }
    });

    setTempColData(data);
  }, [selectedCol]);
  useEffect(() => {
    let categoryD = [];
    if (colData) {
      colData.map((category) => {
        if (
          !catA.includes(category) &&
          !catB.includes(category) &&
          !catC.includes(category)
        ) {
          categoryD.push(category);
        }
      });
      setCatD(categoryD);
    }
  }, [colData]);

  const renderTable = (category) => {
    return (
      <div className="col-md-3 ">
        <div className=" newUiBody p-3">
          {tempColData &&
            category.map((catName, key) => {
              if (tempColData.includes(catName)) {
                return (
                  <div
                    key={key}
                    className="mb-3 newUiBody Subject underline fade-in-up show"
                  >
                    <div className="Subject p-2 bg-white shadow-sm rounded ">
                      <TYGraph
                        yearDif={yearDif}
                        defCode={catName}
                        viewMonth={viewMonth}
                        title={catName}
                        chartType={chartType}
                        cMonthsData={cMonthsData}
                      />
                      {/* /////old one ////// */}
                      {/* <TYGraphView
                        yearDif={yearDif}
                        defCode={catName}
                        viewMonth={viewMonth}
                        title={catName}
                        chartType={chartType}
                        cMonthsData={cMonthsData}
                      /> */}
                    </div>
                  </div>
                );
              }
            })}
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid">
      {/* Header Row with Dropdown and Controller */}
      <div className="row bg-dark text-light py-2 align-items-start">
        {/* Dropdown Column */}
        <div className="col-md-2 ">
          <div className="">
            <div
              className="dropdown "
              style={{ border: "1px solid white", borderRadius: "5px" }}
            >
              <button
                style={{ width: "100%" }}
                className="btn btn-dark dropdown-toggle "
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Select Head
              </button>
              <ul
                className="dropdown-menu dropdown-menu-light papaDivNM"
                style={{ width: "100%", maxHeight: "300px", overflowY: "auto" }}
              >
                <li className="px-2 py-1">
                  <button
                    className="btn btn-sm btn-outline-success me-2"
                    onClick={handleSelectAll}
                  >
                    Select All
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={handleClearAll}
                  >
                    Clear All
                  </button>
                </li>
                <hr className="dropdown-divider" />
                {colData &&
                  colData.map((colName, key) => (
                    <li key={key} className="dropdown-item">
                      <div className="form-check " style={{ fontSize: "12px" }}>
                        <input
                          style={{ cursor: "pointer" }}
                          className="form-check-input"
                          onClick={handleClick}
                          type="checkbox"
                          id={`col-${key}`}
                          name="columns"
                          value={colName}
                          checked={selectedCol[colName] || false}
                          readOnly
                        />
                        {bestSheetDataObj.columnName &&
                          bestSheetDataObj.columnName.map((obj, key) => {
                            if (obj.original === colName) {
                              return (
                                <label
                                  className="form-check-label"
                                  htmlFor={`col-${key}`}
                                >
                                  {obj.label}
                                </label>
                              );
                            }
                          })}
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Controller Column */}
        <div className="col-md-10">
          <Controller
            setCMonthsData={setCMonthsData}
            cMonthsData={cMonthsData}
            setYearDif={setYearDif}
            setViewMonth={setViewMonth}
            yearDif={yearDif}
            chartType={chartType}
            setChartType={setChartType}
            setOpenStates={setOpenStates}
            openStates={openStates}
          />
        </div>
      </div>

      {/* Graph Display Row */}
      {/* <div className="row mt-2">
        {tempColData?.length === 0 ? (
          <div className="col-12">
            <b className="text-danger">Please select heads to see the graph</b>
          </div>
        ) : null}
        {tempColData &&
          tempColData.map((colName, key) => (
            <div key={key} className="col-md-3 mb-3">
              <div className="Subject p-2 bg-white shadow-sm rounded">
                <TYGraphView
                  yearDif={yearDif}
                  defCode={colName}
                  viewMonth={viewMonth}
                  title={colName}
                  chartType={chartType}
                  cMonthsData={cMonthsData}
                />
              </div>
            </div>
          ))}
      </div> */}

      {/* Graph Display Row */}
      <div
        className="row mt-2"
        onClick={() => setOpenStates({ selectMonth: false })}
      >
        {tempColData?.length === 0 ? (
          <div className="col-12">
            <b className="text-danger">Please select heads to see the graph</b>
          </div>
        ) : null}
        {renderTable(catA)} {renderTable(catB)} {renderTable(catC)}
        {renderTable(catD)}
      </div>
    </div>
  );
};
export default GraphView;
